/**
 * @module tree/defer
 */

/**
 * @typedef {Document|DocumentFragment|Element|Text} Target
 * @typedef {*} Param
 */

import resolvable from '../utils/resolvable.js'

/**
 * Registers a task to call on each animation frame until that
 * task returns true
 * @param {Target} target
 * @param {function(target:Target, ...params:Param):Promise<Boolean>} task
 * @param {...Param} params
 */
export default async (
  target,
  task,
  ...params
) => {
  const { ownerDocument } = target
  const { defaultView } = ownerDocument ?? target
  const { requestAnimationFrame } = defaultView
  const [promise, { resolve }] = resolvable()
  
  const defer = () => {
    requestAnimationFrame(async () => {
      if (await task(target, ...params)) {
        return resolve(target)
      }
      
      defer()
    })
  }
  
  defer()
  
  return promise
}
